var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"cursor-pointer",attrs:{"src":require("@/assets/icons/image.svg"),"width":"25","height":"25"},on:{"click":function($event){return _vm.$refs.fileInput.click()}}}),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.handleFileUpload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }